<app-dialog-header title="Amending Visit Requirements" (closeClicked)="onCancel()">
</app-dialog-header>

@if (!loading) {
<p style="padding: 16px 24px 0 24px;">Please use caution when amending a booked visit, as if there is insufficient
  resource for the amended visit, it will
  be unbooked and set to REFERRED status.</p>
<mat-dialog-content [formGroup]="parentForm" style="padding-top: 16px;">
  <p>Manage up to {{maxTickets}} tickets for this visit.</p>
  @if (ticketFormArray.length === 0) {
  <div>
    <p>No tickets currently assigned.</p>
  </div>
  }
  <div formArrayName="ticketFormArray" class="ticket-list">
    @for (ticketCtrl of getTicketsControls(); track trackByIndex(i); let i = $index) {
    <div [formGroupName]="i" class="ticket-row">
      <mat-form-field appearance="fill" class="form-field">
        <mat-label>Skill Profile</mat-label>
        <mat-select formControlName="skillProfileId">
          @for (s of skillProfiles; track s) {
          <mat-option [value]="s.id">
            {{ s.description }}
          </mat-option>
          }
        </mat-select>
        @if (ticketCtrl.get('skillProfileId').invalid) {
        <mat-error>Required</mat-error>
        }
      </mat-form-field>
      <mat-form-field appearance="fill" class="form-field">
        <mat-label>Duration (minutes)</mat-label>
        <input matInput type="number" formControlName="duration" min="1" />
        @if (ticketCtrl.get('duration').invalid) {
        <mat-error>Must be positive</mat-error>
        }
      </mat-form-field>
      <button mat-icon-button type="button" (click)="removeTicket(i)" aria-label="Remove Ticket"
        [disabled]="!canRemoveTicket">
        <mat-icon>delete</mat-icon>
      </button>
    </div>
    }
  </div>
  <div class="add-ticket-row">
    <button mat-button type="button" (click)="addTicket()" [disabled]="!canAddTicket">
      Add Ticket
    </button>
    @if (!canAddTicket) {
    <span class="max-tickets-msg">Max 2 tickets allowed.</span>
    }
  </div>
</mat-dialog-content>
<mat-dialog-actions>
  <span class="spacer"></span>
  <button mat-flat-button color="primary" (click)="onSave()" [disabled]="saving">Save</button>
</mat-dialog-actions>
} @else {
<mat-dialog-content>
  <div class="loading-container">
    <mat-spinner diameter="48"></mat-spinner>
    <p>Loading...</p>
  </div>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-button (click)="onCancel()">Cancel</button>
</mat-dialog-actions>
}